module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/nba/survive_wt-96aa12dc3efdb4b8ee288ef8980ea2b2.svg";